import { ReactFlowProvider } from '@xyflow/react';
import Sidebar from '../Components/_dataset/Sidebar';
import { Box } from '@mui/material';
import DatasetFilter from '../Components/DataSet/DatasetFilter';
import Canvas from '../Components/_dataset/Canvas';
import { useState } from 'react';
import { IFilter } from '../Components/DataSet/types/BottomBarInterfaces';
import Actions from '../Components/_dataset/Actions';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useDispatch, useSelector } from 'react-redux';
import { UpdateConnections, SelectConnection } from '../redux/_Dataset/dataset.action';
import { RootState } from '../redux';
import { useEffect } from 'react';
import { colors } from '../Components/ChartOptions/Color/ColorScheme';

function NewDataset() {
  const dispatch = useDispatch();

  const connections = useSelector((state: RootState) => state.dataset.connections);
  const location = useLocation();
  const flatfileId = location.state?.flatfileId;
  /**all filters applied will be stored in the array */
  const [dataSetFilterArray, setDataSetFilterArray] = useState<IFilter[]>([]);
  const [isDataSetVisible, setIsDataSetVisible] = useState(false);
  const [singleSidebar, setSingleSidebar] = useState(true);
  const [sidebarWidth, setSidebarWidth] = useState(15);
  const [showSidebar, setShowSidebar] = useState(true);

  const onConnectionDelete = (connectionId: string) => {
    setDataSetFilterArray(
      dataSetFilterArray.filter((filter) => filter.connectionId !== connectionId),
    );
  };
  const onTableUncheck = (tableIds: string[]) => {
    setDataSetFilterArray(
      dataSetFilterArray.filter((filter) => !tableIds.includes(filter.tableId)),
    );
  };

  useEffect(() => {
    if (!flatfileId) return;

    setShowSidebar(true);
    setSingleSidebar(false);

    const idx = connections.length % colors.length;

    const newConnection = {
      id: flatfileId,
      label: location.state?.workspaceName ?? 'Flatfile',
      fileType: 'flatfile' as const,
      workSpaceId: location.state?.parentId,
      vendor: undefined,
      color: colors[idx],
      isNew: true,
      workspaces: location.state?.workspacePath ?? [location.state?.parentId],
    };

    dispatch(UpdateConnections([...connections, newConnection]));
    dispatch(SelectConnection(flatfileId));
  }, [flatfileId]);

  return (
    <>
      <Helmet prioritizeSeoTags defer>
        <title>New Dataset | Silzila</title>
      </Helmet>
      <ReactFlowProvider>
        <Box
          key={location.pathname}
          sx={{
            width: '100%',
            display: 'flex',
            height: '100%',
          }}
        >
          <Sidebar
            onConnectionDelete={onConnectionDelete}
            onTableUncheck={onTableUncheck}
            onSidebarWidthChange={setSidebarWidth}
            showSidebar={showSidebar}
            setShowSidebar={setShowSidebar}
            setSingleSidebar={setSingleSidebar}
            autoOpenFlatfileTree={!!flatfileId}
          />

          <Box
            sx={{
              flexGrow: 1,
              minWidth: 0,
              overflow: 'hidden',
            }}
          >
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                height: 'calc(100% - 3rem)',
                position: 'relative',
                flexGrow: 1,
                '& .react-flow__minimap': {
                  right: isDataSetVisible ? '100px !important' : '40px !important',
                },
              }}
            >
              <Canvas
                key="newdataset"
                onTableUncheck={onTableUncheck}
                datasetFilterWidth={isDataSetVisible ? 13.4 : 2.7}
                sidebarWidth={sidebarWidth}
                showSidebar={showSidebar}
                singleSidebar={singleSidebar}
              />
              <DatasetFilter
                editMode={true}
                dataSetFilterArray={dataSetFilterArray}
                setDataSetFilterArray={setDataSetFilterArray}
                isDataSetVisible={isDataSetVisible}
                setIsDataSetVisible={setIsDataSetVisible}
              />
            </Box>
            <Actions datasetFilters={dataSetFilterArray} />
          </Box>
        </Box>
      </ReactFlowProvider>
    </>
  );
}

export default NewDataset;
